import React, { createContext } from "react";

export type CarouselContextType = {
  slides: string[];
  setSlides: React.Dispatch<React.SetStateAction<string[]>>;
  slidesCount: number;
  containerWidth: number;
  setContainerWidth: React.Dispatch<React.SetStateAction<number>>;
  index: number;
  setIndex: React.Dispatch<React.SetStateAction<number>>;
  canGoBack: boolean;
  canGoForward: boolean;
  goForward: () => void;
  goBack: () => void;
  scrollOffset: number;
  hover: boolean;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
  goTo: (targetIndex: number) => void;
};

export const CarouselContext = createContext<CarouselContextType>({
  slides: [],
  setSlides: () => {},
  slidesCount: 0,
  containerWidth: 0,
  setContainerWidth: () => {},
  index: 0,
  setIndex: () => {},
  canGoBack: false,
  canGoForward: false,
  goForward: () => {},
  goBack: () => {},
  scrollOffset: 0,
  hover: false,
  setHover: () => {},
  goTo: () => {}
});
